import { useState, useEffect } from "react";
import { DEFAULT_FETCH_PARAM_SIZE } from "../../../helpers/constant/misc";
import { useIsMounted } from "../../../hooks/useIsMounted";
import { Domain } from "../../../services/Domain";
import { useSelector } from "react-redux";
import { getSettingsObject } from "../../../reducers/setting/setting.selector";

export const useFetchDomains = () => {
    const settingsObject = useSelector(getSettingsObject);
    const [domains, setDomains] = useState([]);

    const [loadingDomains, setLoadingDomains] = useState({
        isLoading: false,
        error: false
    });

    const isMounted = useIsMounted();

    function getParams() {
        let params = {};

        params["order_by"] = "id";
        params["order_direction"] = "ASC";
        params["size"] = DEFAULT_FETCH_PARAM_SIZE;

        return params;
    }

    async function getDomains() {
        try {
            setLoadingDomains({ isLoading: true, error: false });
            const response = await Domain.fetchDomainList(getParams());
            if (response.success && isMounted()) {
                let receivedDomains = [];
                for (let p of response.data.domains.rows) {
                    receivedDomains.push({
                        label: p.domain,
                        value: p.domain,
                    });
                }
                setDomains([...domains, ...receivedDomains]);
                setLoadingDomains({ isLoading: false, error: false });
            } else {
                throw new Error(response.error.message);
            }
        } catch (error) {
            if (isMounted()) {
                setDomains([]);
                setLoadingDomains({ isLoading: false, error: true });
            }
            console.trace(error.message || error);
        }
    }

    useEffect(() => {
        getDomains();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (settingsObject.default_domain && domains.filter(d => d.value === settingsObject.default_domain).length === 0) {
            setDomains([...domains, {
                label: settingsObject.default_domain,
                value: settingsObject.default_domain,
            }]);
        }
    }, [settingsObject, domains]);



    return {
        loadingDomains,
        domains
    };
};
